export const WorkCompletePage = () => {
  return <>WorkCompletePage</>;
};
